import React, { useState, useEffect } from "react";
import { Form, Select, Radio, Input, Button } from "antd";
import './createProfile.css'
import { hobbies, heightList, qualificationList, occupationList, incomeList } from "../../data";
import { countryAndcities } from '../../cities'
import { useDispatch, useSelector } from "react-redux";
import { createProfile } from "../../Redux/features/User/userSlice";
import { useCookies } from 'react-cookie'



const { Option } = Select;


const CreateProfile = () => {
  //eslint-disable-next-line
  const [cookies, setCookie, removeCookie] = useCookies(['x-auth-token']);
  const token = useSelector((state) => state.user.token);
  useEffect(() => {
    if (token) {
      setCookie('x-auth-token', token, {
        path: '/',
        maxAge: 60 * 60 * 24 * 7 * 4 * 12,
        sameSite: true,
      });
    }
    //eslint-disable-next-line
  }, [token])
  const [form] = Form.useForm();
  const [maritalStatus, setMaritalStatus] = useState("Never Married");
  const [haveKids, setHaveKids] = useState(false);
  const [health, setHealth] = useState("No Health Problems");
  const [disability, setDisability] = useState(false);
  const dispatch = useDispatch();



  const handleMaritalStatusChange = (value) => {
    setMaritalStatus(value);
  };
  const handlKidsChnage = (value) => {
    setHaveKids(value.target.value);
  };
  const handleDisability = (value) => {
    setDisability(value.target.value);
  };

  const handleSubmit = () => {
    const formData = {
      ...form.getFieldsValue()
    }
    let userData = {
      header: cookies['x-auth-registration'],
      data: formData
    }
    // console.log(data)
    dispatch(createProfile(userData))
    removeCookie(['x-auth-registration'])
  }
  return (
    <>
      <Form form={form} className="customContainer" onFinish={handleSubmit}>
        <div className="mainTitle">Creating your Profile</div>

        <div className="title">Personal Details</div>

        <Form.Item name="height" label="Your Height">
          <Select showSearch>
            {heightList.map((height, index) => (
              <Option key={index} value={height}>{height}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Body Type"
          name="bodyType"
        >
          <Select showSearch>
            <Option value="Slim">Slim</Option>
            <Option value="Athletic">Athletic</Option>
            <Option value="Average">Average</Option>
            <Option value="slightly Over Weight">slightly Over Weight</Option>
            <Option value="Over Weight">Over Weight</Option>
          </Select>
        </Form.Item>
        <Form.Item
          label="Marital Status"
          name="maritalStatus"
        >
          <Select showSearch value={maritalStatus} onChange={handleMaritalStatusChange}>
            <Option value="Never Married">Never Married</Option>
            <Option value="Divorced">Divorced</Option>
            <Option value="Widowed">Widowed</Option>
            <Option value="Awaiting Divorce">Awaiting Divorce</Option>
            <Option value="Annulled">Annulled</Option>
          </Select>
        </Form.Item>
        <Form.Item name="haveKids" label="Do You Have Kids">
          <Radio.Group value={haveKids} onChange={handlKidsChnage}>
            <Radio value={true}>Yes</Radio>
            <Radio value={false}>No</Radio>
          </Radio.Group>
        </Form.Item>
        {haveKids && (
          <Form.Item name="totalKids" label="Number of Kids:">
            <Select showSearch>
              <Option value="0">0</Option>
              <Option value="1">1</Option>
              <Option value="2">2</Option>
              <Option value="3+">3+</Option>
            </Select>
          </Form.Item>
        )}
        {haveKids && (
          <Form.Item name='kidsLiveWithYou' label="Kids live with you">
            <Radio.Group>
              <Radio value={true}>Yes</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>
        )}

        <Form.Item name="bloodGroup" label="Blood Group">
          <Select showSearch>
            <Option value="A+">A+</Option>
            <Option value="A-">A-</Option>
            <Option value="B+">B+</Option>
            <Option value="B-">B-</Option>
            <Option value="AB+">AB+</Option>
            <Option value="AB-">AB-</Option>
            <Option value="O+">O+</Option>
            <Option value="O-">O-</Option>
          </Select>
        </Form.Item>

        <Form.Item name="grewUpIn" label="You Grew Up In">
          <Select showSearch>
            {countryAndcities.map((country, index) => (
              <Option key={index} value={country.country_name}>{country.country_name}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="healthInfo" label="Health">
          <Select value={health} onChange={setHealth} showSearch>
            <Option value="No Health Problems">No Health Problems</Option>
            <Option value="HIV positive" >HIV positive</Option>
            <Option value="Diabetes" >Diabetes</Option>
            <Option value="Low BP" >Low BP</Option>
            <Option value="High BP">High BP</Option>
            <Option value="Heart Ailments">Heart Ailments</Option>
            <Option value="Other">Other</Option>
          </Select>
        </Form.Item>
        {health === "Other" && <Form.Item name="healthInfoOther" label="Type here about your Health">
          <Input />
        </Form.Item>}
        <Form.Item name="disability" label="Any Disability">
          <Radio.Group value={disability} onChange={handleDisability}>
            <Radio value={true}>Yes</Radio>
            <Radio value={false}>No</Radio>
          </Radio.Group>
        </Form.Item>
        {disability && <Form.Item name="disabilityOther" label="Type here about your Disability">
          <Input />
        </Form.Item>}

        <div className="title">Family Details</div>

        <Form.Item name="familyLocation" label="Family Location">
          <Select showSearch>
            {countryAndcities.map((country, index) => (
              <Option key={index} value={country.country_name}>{country.country_name}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="familyAffluence" label="Family Affluence">
          <Select showSearch>
            <Option value="Affluent">Affluent</Option>
            <Option value="Upper Middle Class">Upper Middle Class</Option>
            <Option value="Middle Class">Middle Class</Option>
            <Option value="Lower Middle Class">Lower Middle Class</Option>
            <Option value="Poor">Poor</Option>
          </Select>
        </Form.Item>
        <Form.Item name="familyValues" label="Family Values">
          <Radio.Group>
            <Radio value="Traditional">Traditional</Radio>
            <Radio value="Moderate">Moderate</Radio>
            <Radio value="Liberal">Liberal</Radio>
          </Radio.Group>
        </Form.Item>


        <div className="title">Education & Career Details</div>
        <Form.Item name="qualification" label="Highest Education">
          <Select showSearch >
            {qualificationList.map((qualification, index) => (
              <Option key={index} value={qualification}>
                {qualification}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="occupation" label="Working As">
          <Select showSearch >
            {occupationList.map((occupation, index) => (
              <Option key={index} value={occupation}>
                {occupation}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="annualIncome" label="Annual Income">
          <Select showSearch >
            {incomeList.map((income, index) => (
              <Option key={index} value={income}>
                {income}
              </Option>
            ))}
          </Select>
        </Form.Item>


        <div className="title">Life Style</div>
        <Form.Item name="diet" label="Diet">
          <Radio.Group>
            <Radio value="Veg">Veg</Radio>
            <Radio value="Occasionally Veg">Occasionally Veg</Radio>
            <Radio value="Non-Veg">Non-Veg</Radio>
            <Radio value="Occasionally Non-Veg">Occasionally Non-Veg</Radio>
            <Radio value="Eggetarian">Eggetarian</Radio>
            <Radio value="Jain">Jain</Radio>
            <Radio value="Vegan">Vegan</Radio>
            <Radio value="Other">Other</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item name="smoke" label="Do You Smoke?">
          <Radio.Group >
            <Radio value="No">No</Radio>
            <Radio value="Yes">Yes</Radio>
            <Radio value="Occasionally">Occasionally</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item name="drink" label="Do You Drink?">
          <Radio.Group>
            <Radio value="No">No</Radio>
            <Radio value="Yes">Yes</Radio>
            <Radio value="Occasionally">Occasionally</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item name="drug" label="Do You Take Drugs?">
          <Radio.Group >
            <Radio value="No">No</Radio>
            <Radio value="Yes">Yes</Radio>
            <Radio value="Occasionally">Occasionally</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item name="hobbies" label="Interests And Hobbies">
          <Select mode="multiple" >
            {hobbies.map((hobby, index) => (
              <Option key={index} value={hobby.value}>
                {hobby.value}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <div className="title">Few words about you</div>

        <Form.Item name="aboutMe" label="About You">
          <Input.TextArea placeholder="Hello, here is a quick introduction about me.
I have completed my B.Tech. I am focused about my career, but makes it a point to I give equal attention to family as well. 
Please drop in a message if you would like to know more."  rows={5} />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">Complete Your Profile</Button>
        </Form.Item>
      </Form>
    </>
  )
}

export default CreateProfile